<template>
  <a-card :bordered="false">
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :pageNum="pageNum"
      :data="loadData"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="message" slot-scope="text" v-html="text" class="multi-line-ellipsis">
      </div>
      <span slot="tags" slot-scope="text">
        <a-tag
          :color="text === 0 ? 'volcano' : 'green'"
        >
          {{ text === 0 ? '未读' : '已读' }}
        </a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleDetail(record)">查看</a>
        </template>
      </span>
    </s-table>
    <message-dialog-form
      v-if="showDetailDialog"
      :visible="showDetailDialog"
      :loading="loading"
      :text="message"
      @cancel="handleUserMessageCancel"
    />
  </a-card>
</template>

<script>
import { STable } from '@/components'
import MessageDialogForm from './MessageDialogForm'
import { user_message_list, user_message_update } from '@/api/user'

export default {
  name: 'TableList',
  components: {
    STable,
    MessageDialogForm
  },
  data () {
    return {
      pageNum: 1,
      loading: false,
      showDetailDialog: false,
      message: undefined,
      // 查询参数
      queryParam: {},
      dataModuleList: this.$Dictionaries.dataModuleList,
      // 表头
      columns: [
        {
          title: '序号',
          width: 100,
          scopedSlots: { customRender: 'serial' }
        },
       {
          title: '消息内容',
          dataIndex: 'message',
          scopedSlots: { customRender: 'message' }
        },
        {
          title: '状态',
          width: 150,
          dataIndex: 'is_read',
          scopedSlots: { customRender: 'tags' }
        },
        {
          title: '时间',
          width: 150,
          dataIndex: 'create_time'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 180,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return user_message_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      }
    }
  },
  created () {
    this.setCurrentPage()
  },
  methods: {
    setCurrentPage () {
      // const page = sessionStorage.getItem('CurrentPage')
      const page = this.$store.getters.pop
      if (page) {
        const current = page.split('#$$#')[0]
        const query = page.split('#$$#')[1]
        const path = page.split('#$$#')[2]
        sessionStorage.removeItem('CurrentPage')
        if (path === this.$route.path) {
          if (!isNaN(Number(current))) {
            this.pageNum = Number(current)
          }
          if (query) {
            this.queryParam = JSON.parse(query)
          }
        } else {
          this.queryParam = {}
          this.$store.dispatch('clear')
        }
      }
    },
    handleDetail (record) {
      this.message = record.message
      this.showDetailDialog = true
      if (record.is_read === 0) {
        user_message_update({ is_read: 1 }, record.id).then(res => {
          if (res.code === 1000) {
            this.$refs.table.refresh()
          }
        })
      }
    },
    handleUserMessageCancel () {
      this.showDetailDialog = false
    }
  }
}
</script>
<style scoped>
.multi-line-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 3em; /* 假设一行1.5em */
}
</style>
